export default (that) => [
  {
    field: 'seq',
    width: 30,
    align: 'center',
    fixed: 'left',
    type: 'seq',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_displayScm') || '工厂',
    field: 'scmName',
    align: 'left',
    minWidth: 220,
  },
  {
    title: that.$l('table_label_fbaDc') || 'FBA配送中心',
    field: 'fbaDc',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fbaId') || 'FBA货件编号',
    field: 'fbaId',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fbaIdReferenceId') || 'FBA货件追踪编号',
    field: 'fbaIdReferenceId',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
]
